<template>
  <main class="fj-main">
    <nuxt :nuxt-child-key="fullRouteName" />
    <BackTop :bottom="100" :right="30">
      <div class="back-top return-to-top-btn">
        <i class="triangle-icon triangle-icon-000 p-a c-c d-b"></i>
      </div>
    </BackTop>
  </main>
</template>

<script>
  export default {
    name: 'AppMain',
    data() {
      return {}
    },
    computed: {
      fullRouteName() {
        return this.$route.name
      }
    },
    created() {},
    mounted() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .fj-main {
    flex: 1;
    // background: #000;
  }
  .back-top {
    width: 52px;
    height: 52px;
    border-radius: 100%;
    box-shadow: 0px 2px 6px 0px rgb(0 0 0 / 17%);
    background-color: #fff;
  }
</style>
